// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDwlIgA4492ivT20WLypD0mUVMlSeynieU",
  authDomain: "aasani-fe829.firebaseapp.com",
  projectId: "aasani-fe829",
  storageBucket: "aasani-fe829.firebasestorage.app",
  messagingSenderId: "246316190471",
  appId: "1:246316190471:web:dc3c636fc8523c580053a2",
  measurementId: "G-Y0BS4RMWTB"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
export const firestore=getFirestore(app);